/**
 * Lifted child theme — site-specific JavaScript entry.
 * Built to dist/child.js via npm run build.
 */

const FOOTER_ACCORDION_MQ = window.matchMedia('(max-width: 1023px)');

function initFooterAccordions() {
	const headers = document.querySelectorAll('[data-footer-accordion-header]');

	if (!headers.length) {
		return;
	}

	function getPanel(header) {
		const panelId = header.getAttribute('aria-controls');
		return panelId ? document.getElementById(panelId) : null;
	}

	function setMobileMode(header, panel) {
		header.setAttribute('tabindex', '0');
		header.setAttribute('aria-expanded', 'false');
		panel.hidden = true;
	}

	function setDesktopMode(header, panel) {
		header.setAttribute('tabindex', '-1');
		header.setAttribute('aria-expanded', 'true');
		panel.hidden = false;
	}

	function applyMode() {
		headers.forEach((header) => {
			const panel = getPanel(header);
			if (!panel) {
				return;
			}

			if (FOOTER_ACCORDION_MQ.matches) {
				setMobileMode(header, panel);
			} else {
				setDesktopMode(header, panel);
			}
		});
	}

	headers.forEach((header) => {
		header.addEventListener('click', () => {
			if (!FOOTER_ACCORDION_MQ.matches) {
				return;
			}

			const panel = getPanel(header);
			if (!panel) {
				return;
			}

			const expanded = header.getAttribute('aria-expanded') === 'true';
			header.setAttribute('aria-expanded', String(!expanded));
			panel.hidden = expanded;
		});
	});

	applyMode();

	if (typeof FOOTER_ACCORDION_MQ.addEventListener === 'function') {
		FOOTER_ACCORDION_MQ.addEventListener('change', applyMode);
	} else {
		FOOTER_ACCORDION_MQ.addListener(applyMode);
	}
}

document.addEventListener('DOMContentLoaded', initFooterAccordions);
